import styles from './style.module.scss';
import { SearchResultItem } from '../../helpers/apiService';
import { Headline } from '../headline/headline';
import { IconWithLabel } from '../iconWithLabel/iconWithLabel';
import { Copy } from '../copy/copy';

interface IProps {
	item: SearchResultItem;
}
export function Item({ item }: IProps) {
	const { PositionTitle, JobCategory, CareerLevel, PositionLocation, PositionSchedule, PositionURI } =
		item.MatchedObjectDescriptor;
	return (
		<a className={styles.resultItem} href={PositionURI} target="_blank">
			<div className={styles.headlineWrapper}>
				<Headline tag={'h4'}>{PositionTitle}</Headline>
			</div>
			<ul className={styles.listWrapper}>
				{JobCategory && JobCategory[0] && (
					<IconWithLabel tag={'li'} className={styles.company}>
						<Copy text={JobCategory[0].Name} />
					</IconWithLabel>
				)}
				{CareerLevel && CareerLevel[0] && (
					<IconWithLabel tag={'li'} className={styles.profile}>
						<Copy text={CareerLevel[0].Name} />
					</IconWithLabel>
				)}
				{PositionSchedule && PositionSchedule[0] && (
					<IconWithLabel tag={'li'} className={styles.document}>
						<Copy text={PositionSchedule[0].Name} />
					</IconWithLabel>
				)}
				{PositionLocation && PositionLocation[0] && (
					<IconWithLabel tag={'li'} className={styles.location}>
						<Copy text={PositionLocation[0].CityName} />
					</IconWithLabel>
				)}
			</ul>
		</a>
	);
}
